import { render } from "./DocumentosPacienteAdmin.vue?vue&type=template&id=c17bc99c"
import script from "./DocumentosPacienteAdmin.vue?vue&type=script&lang=js"
export * from "./DocumentosPacienteAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__